module.exports = __webpack_public_path__ + "img/xxx.fd2fbe4.png";